import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

// Auth is now cookie-based (httpOnly `access_token` set by the backend on
// login). `withCredentials` ensures axios sends the cookie on every call.
export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
    (r) => r,
    (e) => {
        if (e.response?.status === 401 && !window.location.pathname.startsWith("/login")
            && !window.location.pathname.startsWith("/set-password")
            && !window.location.pathname.startsWith("/forgot-password")) {
            window.location.href = "/login";
        }
        return Promise.reject(e);
    }
);

export function formatErr(detail) {
    if (!detail) return "Something went wrong.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) return detail.map(d => d?.msg || JSON.stringify(d)).join(" ");
    return String(detail);
}
